<template>
  <div class="contrast" :style="{'margin-top': is_share ? '0' : '.3rem' }">
    <p class="title" v-if="cItem.hide_title == 0 && !is_share">
      <img :src="static_img_url + 'mobile/pic/tct_icon.png'" />
      {{cItem.title}}
    </p>
    <div class="contrast-summary" v-html="cItem.summary" v-if="!is_share"></div>
    <div style="position: relative; overflow: hidden; min-height: 1.2rem">
      <div style="width: 0; height: 0; overflow: hidden;">
        <div class="chart" :id="'sabkey' + cItem.id"></div>
      </div>
      <img :src="imgbase" :preview="cItem.id" v-show="imgbase" class="imgbase"/>
      <div class="loading_img" v-if="!imgbase">
        <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
      </div>
    </div>
    
    <div class="share-area" v-if="!is_share">
      <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
      <div class="right">
        <span>分享至</span>
        <div @click="handleClickShare">
          <i class="iconfont">&#xe641;</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { option } from "js/chart_sabkey";
import echarts from "echarts";
import filter from "mobile/js/filter";
import html2canvas from "html2canvas";
export default {
  props: ["cItem", "uid", "entityNtag", "tctBusinessNature"],
  data() {
    return {
      option: option,
      filter: filter,
      my_chart: "",
      imgbase: '',
      nodes: [],
      links: []
    };
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url;
    },
    is_share() {
      return (
        this.$route.name == "MShareScatter" ||
        this.$route.name == "MShareScatterWx"
      );
    }
  },
  methods: {
    goTopicDetail(item_uid) {
      const { href } = this.$router.resolve({
        name: "NewsDetail",
        params: {
          uid: item_uid
        }
      });
      window.open(href, "_blank");
    },
    greatChart() {
      let chart = echarts.init(document.getElementById("sabkey" + this.cItem.id));
      this.option.series[0].links = this.links;
      this.option.series[0].data = this.nodes;
      this.option.series[0].animation = false;
      let type2 = this.nodes.filter(item => item.type == 2)
      let type4 = this.nodes.filter(item => item.type == 4)
      let len2 = this.links.filter(item => {
        let i = type2.findIndex(a => a.name == item.source)
        return i > -1
      }).length
      let len4 = this.links.filter(item => {
        let i = type4.findIndex(a => a.name == item.target)
        return i > -1
      }).length
      let hgt = Math.max(len2, len4) * 38
      chart.resize({height: hgt})
      let arr = [];
      chart.setOption(this.option);
      chart.off("click");
      // chart.on("click", params => {
      //   if(params.data.type == 3) {
      //     this.active_name = params.data.name
      //     this.show_list = this.cItem.content.res.filter(a => a.business_desc == params.data.name)
      //     this.detail_modal = true
      //   }
      // });
      this.$nextTick(() => {
        setTimeout(() => {
          html2canvas(document.getElementById('sabkey'+this.cItem.id),{ scale: 2}).then((canvas) => {
            let save_url= canvas.toDataURL("image/png")
            this.$set(this.$data, 'imgbase', save_url)
            if(this.is_share) {
              this.$emit('greatImg', true)
            }
            this.$previewRefresh()
          })
        }, 1000)
      })
    },
    handleClickShare() {
      this.$router.push({name: 'MShareScatter', query: { tct_id: this.cItem.id,  theme_uid: this.uid}})
    }
  },
  created() {
    let allowing = []
    this.cItem.content.res.map(a => {
      if (a.business_desc != null && a.business_nature != null && a.entity_ntag_id) {

        let ptag_name = this.filter.getPgidName(a.entity_ntag_id, this.entityNtag),
          tag_name = this.filter.getPidName(a.entity_ntag_id, this.entityNtag),
          business_desc = a.business_desc,
          business_name = this.filter.dealName(a.business_nature, this.tctBusinessNature)

        allowing.push(
          {source: ptag_name, target: tag_name, value: 1},
          {source: tag_name, target: business_desc, value: 1},
          {source: business_desc, target: business_name, value: 1}
        )

        // 一级
        let index1 = this.nodes.findIndex(b => b.name == ptag_name)
        if (index1 == -1) {
          this.nodes.push({ name: ptag_name , type: 1, value: 1, value1: 1});
        } else {
          this.nodes[index1].value1++
        }
        // 二级
        let index2 = this.nodes.findIndex(b => b.name == tag_name)
        if (index2 == -1) {
          this.nodes.push({ name: tag_name , type: 2, value: 1, value1: 1});
        } else {
          this.nodes[index2].value1++
        }
        // 三级
        let index3 = this.nodes.findIndex(b => b.name == business_desc);
        if (index3 == -1) {
          this.nodes.push({ name: business_desc , type: 3, value: 1, value1: 1});
        } else {
          this.nodes[index3].value1++
        }
        // 四级
        let index4 = this.nodes.findIndex(b => b.name == business_name)
        if (index4 == -1) {
          this.nodes.push({ name: business_name , type: 4, value: 1, value1: 1});
        } else {
          this.nodes[index4].value1++
        }
      }
    });
    allowing.map(a => {
      let index = this.links.findIndex(b => b.source == a.source && b.target == a.target)
      if (index == -1) {
        this.links.push(a)
      } else {
        // this.links[index].value++
      }
    })
  },
  mounted() {
    this.greatChart();
  }
};
</script>
<style lang="stylus" scoped>
@import '~mobile/styles/constrast.stylus'
@import '~mobile/styles/shareLoading.stylus'
.contrast-summary
  margin 0
.chart
  width 700px
  background url('~pic/watermark-gray.png')
  margin-top .32rem
</style>
